// extracted by mini-css-extract-plugin
export default {"copyableId":"copyableId---lyYit","value":"value---lemFP","copyButton":"copyButton---fQ_05"};